var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HttpClient_instances, _HttpClient_resolveOptions, _HttpClient_request, _HttpClient_parseResponse, _HttpClient_extractResponseBody;
import HttpError from './HttpError';
export var IgnoreErrorMessages;
(function (IgnoreErrorMessages) {
    IgnoreErrorMessages["FAILED_TO_FETCH"] = "Failed to fetch";
    IgnoreErrorMessages["NETWORK_ERROR_FETCHING_RESOURCE"] = "NetworkError when attempting to fetch resource.";
})(IgnoreErrorMessages || (IgnoreErrorMessages = {}));
var RequestMethods;
(function (RequestMethods) {
    RequestMethods["DELETE"] = "delete";
    RequestMethods["GET"] = "get";
    RequestMethods["POST"] = "post";
    RequestMethods["PUT"] = "put";
})(RequestMethods || (RequestMethods = {}));
var ContentTypes;
(function (ContentTypes) {
    ContentTypes["FORM_URLENCODED"] = "application/x-www-form-urlencoded; charset=UTF-8";
    ContentTypes["JSON"] = "application/json";
})(ContentTypes || (ContentTypes = {}));
export class HttpClient {
    constructor() {
        _HttpClient_instances.add(this);
    }
    static convertFormDataToQueryString(data) {
        const params = Array.from(data, ([key, value]) => [
            key,
            typeof value === 'string' ? value : value.name
        ]);
        return new URLSearchParams(params).toString();
    }
    get(url, options) {
        const requestOptions = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_resolveOptions).call(this, RequestMethods.GET, options);
        return __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_request).call(this, url, requestOptions);
    }
    post(url, data, options) {
        const defaultOptions = {
            body: data,
            headers: {
                'Content-Type': ContentTypes.FORM_URLENCODED
            }
        };
        const formattedOptions = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_resolveOptions).call(this, RequestMethods.POST, options);
        const requestOptions = {
            ...defaultOptions,
            ...formattedOptions,
            headers: { ...defaultOptions.headers, ...formattedOptions.headers }
        };
        return __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_request).call(this, url, requestOptions);
    }
    put(url, data, options) {
        const defaultOptions = {
            body: data,
            headers: {
                'Content-Type': ContentTypes.FORM_URLENCODED
            }
        };
        const formattedOptions = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_resolveOptions).call(this, RequestMethods.PUT, options);
        const requestOptions = {
            ...defaultOptions,
            ...formattedOptions,
            headers: { ...defaultOptions.headers, ...formattedOptions.headers }
        };
        return __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_request).call(this, url, requestOptions);
    }
    delete(url, options) {
        const requestOptions = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_resolveOptions).call(this, RequestMethods.DELETE, options);
        return __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_request).call(this, url, requestOptions);
    }
}
_HttpClient_instances = new WeakSet(), _HttpClient_resolveOptions = function _HttpClient_resolveOptions(method, options) {
    // eslint-disable-next-line no-constant-condition
    const cache = (options?.cache || true ? 'default' : 'no-cache');
    const isJson = options?.json === undefined ? true : options.json;
    const headers = options?.headers || {};
    const signal = options?.signal || null;
    if (isJson) {
        headers.Accept = ContentTypes.JSON;
    }
    if (isJson && method !== 'delete') {
        headers['Content-Type'] = ContentTypes.JSON;
    }
    return {
        method,
        credentials: 'same-origin',
        cache,
        headers,
        signal
    };
}, _HttpClient_request = async function _HttpClient_request(url, options) {
    const defaultOptions = __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_resolveOptions).call(this, RequestMethods.GET);
    const requestOptions = { ...defaultOptions, ...options };
    try {
        const response = await fetch(url, requestOptions);
        return await __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_parseResponse).call(this, response);
    }
    catch (error) {
        if (error instanceof HttpError && [400, 502, 403].includes(error.status)) {
            return Promise.reject(error);
        }
        if (!(error instanceof Error) ||
            !Object.values(IgnoreErrorMessages).includes(error.message)) {
            throw error;
        }
        return Promise.reject();
    }
}, _HttpClient_parseResponse = async function _HttpClient_parseResponse(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(await __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_extractResponseBody).call(this, response));
    }
    const responseBody = await __classPrivateFieldGet(this, _HttpClient_instances, "m", _HttpClient_extractResponseBody).call(this, response);
    return Promise.reject(new HttpError(response.status, response.statusText, responseBody));
}, _HttpClient_extractResponseBody = function _HttpClient_extractResponseBody(response) {
    const contentType = response.headers.get('content-type');
    if (contentType !== null && contentType.indexOf(ContentTypes.JSON) !== -1) {
        return response.json();
    }
    return response.text();
};
export default new HttpClient();
